export type LoggingFunction = (message?: any, ...optionalParams: any[]) => void;


export function noopFn(): void {}


export class Logger {
  static getLogger(host: string, port: string, console: Console, noop: () => void): Logger {
    const isLocalHost = /^(localhost|127\.0\.0\.1)$/.test(host);
    const isNotKarma = port !== '9876';
    const isNonProd = /^(stg|dev)/.test(host);
    const enableLogging = (isLocalHost && isNotKarma) || isNonProd;

    return new Logger(console, noop, enableLogging);
  }

  private readonly _error: LoggingFunction;
  private readonly _log: LoggingFunction;
  private readonly _warn: LoggingFunction;

  readonly enabled: boolean;

  constructor(console: Console, noop: () => void, enabled: boolean = false) {
    this.enabled = enabled;
    this._error = enabled ? console.error.bind(console) : noop;
    this._log = enabled ? console.log.bind(console) : noop;
    this._warn = enabled ? console.warn.bind(console) : noop;
  }

  get error(): LoggingFunction {
    return this._error;
  }

  get log(): LoggingFunction {
    return this._log;
  }

  get warn(): LoggingFunction {
    return this._warn;
  }
}


export const logger = Logger.getLogger(
  window.location.hostname,
  window.location.port,
  window.console,
  noopFn
);
